// 由 scripts/build-folklore-codex.mjs 自动生成，请勿手改。
// 数据源：民俗研究台账 entries.json（正文条目；已否决条目不进站内，见外部台账）。
// 重新生成：node scripts/build-folklore-codex.mjs [entries.json 路径]

export type CodexCategory = 'doc' | 'oral' | 'fiction';
export type CodexStatus = 'verified' | 'pending';

export interface FolkloreCodexEntry {
  /** 条目编号，如 L06 */
  id: string;
  /** 素材名 */
  name: string;
  /** 类别：doc 文献 / oral 口头传统 / fiction 游戏虚构 */
  category: CodexCategory;
  /** 口头类流传地（文献/虚构为空） */
  region: string;
  /** 出处 */
  source: string;
  /** 出处链接（可空） */
  url: string;
  /** 核对状态：verified 已核对 / pending 原文待核对 */
  status: CodexStatus;
  /** 是否可正式引用（仅已核对的非虚构条目为 true） */
  citable: boolean;
  /** 虚实边界一句话 */
  boundary: string;
  /** 在游戏中的用途/关联站点 */
  usage: string;
  /** 研究台账来源编号，如 S05 */
  sref: string;
}

export const FOLKLORE_CODEX: FolkloreCodexEntry[] = [
  {
    id: "L01",
    name: "徐福传说",
    category: "doc",
    region: "",
    source: "《史记·秦始皇本纪》《封禅书》《淮南衡山列传》；维基「徐福」条（国家级非遗「徐福传说」Ⅰ-41、序号528）；徐洪绕《从非遗项目品味连云港地方特色文化》（江苏省社科联讲座稿，2013）",
    url: "https://zh.wikipedia.org/wiki/徐福",
    status: "verified",
    citable: true,
    boundary: "纠偏：2008年第二批列入的是浙江象山、慈溪；连云港赣榆为2011年扩展列入（三扩），不得把「2008年第二批」安在赣榆头上。籍贯争议尚无定论，转述须保留。",
    usage: "第1站街口旅游铭牌、第2站旧书摊《徐福东渡》旧书等在地环境细节；与沈映禾「被潮水带走」仅作意象呼应、非因果",
    sref: "S01／S02",
  },
  {
    id: "L02",
    name: "吴承恩云台山采风（《淮安府志》转引）",
    category: "doc",
    region: "",
    source: "扬子晚报／紫牛新闻（记者张凌飞，2025年6月\"苏超\"预热稿）转引；新浪新闻转载",
    url: "https://k.sina.com.cn/article_1653603955_628ffe7302001s4ma.html",
    status: "pending",
    citable: false,
    boundary: "2026-10-02核对：转引源已定位，但天启《淮安府志》吴承恩传原文无\"云台山/采风\"字样，\"据《淮安府志》记载\"系旅游宣传口径误引，不可作解谜依据。替代方向：《广阳杂记》无支祁线（待核对）。",
    usage: "第8站旧戏台演西游故事的「在地理由」、第2站旧书摊；为已登记 R10《西游记》第三回错勾母题补背景",
    sref: "S03",
  },
  {
    id: "L03",
    name: "海州古城沿革",
    category: "doc",
    region: "",
    source: "腾讯新闻转扬子晚报「千年古城」报道（2025-11-12）",
    url: "https://news.qq.com/rain/a/20251112A06ANY00",
    status: "pending",
    citable: false,
    boundary: "「2000余年历史」为地方文旅口径、媒体转述，未核对原始出处。",
    usage: "故事地点背景：连云港古称海州，海州古城为老街历史氛围参照",
    sref: "S04",
  },
  {
    id: "L04",
    name: "拉魂腔（淮海戏 · 海州五大宫调）",
    category: "doc",
    region: "",
    source: "海州五大宫调（2006年第一批国家级非遗）、淮海戏（2008年第二批国家级非遗）；徐洪绕讲座稿（江苏省社科联）",
    url: "https://www.js-skl.org.cn/uploads/Files/2018-03/13/1-1520929273-365.pdf",
    status: "verified",
    citable: true,
    boundary: "淮海戏属「拉魂腔」体系；艺人称尾音翻高八度为「起腔」、有「摄人魂魄」之说，为讲座稿转述的艺人原话。",
    usage: "第8站旧戏台声音设计，建议优先采用（半句未唱完的拉魂腔）",
    sref: "S02",
  },
  {
    id: "L05",
    name: "喊魂／招魂制度",
    category: "doc",
    region: "",
    source: "《楚辞·招魂》；《礼记·丧大记》「复」条；郑晓江《中国殡葬文化》（上海文化出版社，2012）；孔飞力《叫魂》",
    url: "",
    status: "verified",
    citable: true,
    boundary: "招魂仪式的存在为文献；「喊对名字能送走母亲」为本作规则（见游戏虚构 F03）。",
    usage: "第5站招魂幡细节；第12站「点灯」前沈归对海喊母亲名字的仪式化回收",
    sref: "S05",
  },
  {
    id: "L06",
    name: "《南齐书·张融传》「登屋复魂」",
    category: "doc",
    region: "",
    source: "《南齐书》卷四十一·列传第二十二《张融传》；维基文库本声明以中华书局1972年点校本为底本",
    url: "",
    status: "verified",
    citable: true,
    boundary: "2026-10-02核对通过。原文：\"遗令建白旌无旒，不设祭，令人捉麈尾登屋复魂\"。可正式引用。",
    usage: "第9站旧胶片里「升屋招魂」剪影的意象出处",
    sref: "S05",
  },
  {
    id: "L07",
    name: "招魂幡（丧葬仪仗）",
    category: "doc",
    region: "",
    source: "维基「招魂」条、「招魂幡」条及丧葬仪仗记载",
    url: "https://zh.wikipedia.org/wiki/招魂",
    status: "verified",
    citable: true,
    boundary: "出处见上；本作中的具体情节与运用为虚构创作。",
    usage: "第5站「石街送行」：一人持招魂幡走在队前（形象来自文献，本作出殡队伍为虚构）",
    sref: "S05",
  },
  {
    id: "L08",
    name: "定陶县志 · 路祭流程",
    category: "doc",
    region: "",
    source: "定陶县志载丧葬流程「先家祭、再路祭、后坟祭」，现据 360doc 转载县志",
    url: "",
    status: "pending",
    citable: false,
    boundary: "2026-10-02核对：360doc转载源已定位归档（含\"长明指魂灯\"/\"先家祭再路祭后坟祭\"原文，自称转引定陶县志、整理人袁博），但县志数字化原文未找到，维持\"网络转载、原文待核对\"，不作解谜依据。",
    usage: "第5站「石街送行」设祭地点与线索卡（供桌摆在巷口）",
    sref: "S07",
  },
  {
    id: "L09",
    name: "定陶县志 · 长明指魂灯",
    category: "doc",
    region: "",
    source: "定陶县志载丧葬点「长明指魂灯」，现据 360doc 转载",
    url: "",
    status: "pending",
    citable: false,
    boundary: "2026-10-02核对：360doc转载源已定位归档（含\"长明指魂灯\"/\"先家祭再路祭后坟祭\"原文，自称转引定陶县志、整理人袁博），但县志数字化原文未找到，维持\"网络转载、原文待核对\"，不作解谜依据。",
    usage: "第12站结局「指魂」层意象：让母亲认得路，对应「沈｜归家」的「归家」",
    sref: "S07",
  },
  {
    id: "L10",
    name: "庆阳祭祀纸扎",
    category: "doc",
    region: "",
    source: "《庆阳纸扎文化探析》，360doc 用户转载",
    url: "http://www.360doc.com/content/25/1106/22/481308_1164453632.shtml",
    status: "pending",
    citable: false,
    boundary: "网络转载，可信度中等偏低；庆阳市级非遗，「国家级」一说未核实不写；「源自先周」等起源论述为转载者观点，不可直接引用。",
    usage: "第6站纸扎铺品类（灵亭、过亭等）与行话细节",
    sref: "S07",
  },
  {
    id: "L11",
    name: "周口纸扎「纸活铺／纸活匠」称谓",
    category: "doc",
    region: "",
    source: "周口晚报PDF《纸扎匠巧手扎出五彩世界》（zhld.com）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "2026-10-02核对：原文链接已归档、实测可打开；内容仍按媒体报道口径使用，细节引文待进一步核对。",
    usage: "第6站纸扎铺称谓与环境真实感细节",
    sref: "S07",
  },
  {
    id: "L12",
    name: "黑白无常形象",
    category: "doc",
    region: "",
    source: "《地藏经》「无常大鬼」；维基「黑白无常」条（链接待补）；大谷亨《马巷城隍庙的保长公（白无常）信仰》（链接待补）；江义雄论文（已登记 R07）",
    url: "",
    status: "verified",
    citable: true,
    boundary: "R07「范谢将军 ≠ 黑白无常」的区分结论可直接用于虚实边界声明。",
    usage: "第11站「黑白无常核名」形象细节：白无常持招魂幡、黑无常持哭丧棒，只认簿上名字不认人",
    sref: "S09",
  },
  {
    id: "L13",
    name: "《南汇县志》· 城隍诞日",
    category: "doc",
    region: "",
    source: "《南汇县志》（钦志）卷十五风俗「四月十二日，传为城隍白夫人诞日」，现据 360doc 转载考据文",
    url: "http://www.360doc.com/content/26/0112/15/86258090_1168294104.shtml",
    status: "pending",
    citable: false,
    boundary: "民间转载，引文待核对县志原文。",
    usage: "城隍信仰背景了解；连云港本地无出处，不正面使用",
    sref: "S07",
  },
  {
    id: "L14",
    name: "城隍「解钱粮」（上海）",
    category: "doc",
    region: "",
    source: "上海地区城隍研究论文（socscires.com 全文 PDF）",
    url: "http://article.ssres.org/pdf/10630056.pdf",
    status: "verified",
    citable: true,
    boundary: "学术论文，可信度中高；地域限定江南／上海，引用时不得泛化。",
    usage: "第11站背景压迫感：无常核名时提一句「城隍老爷的簿子」，暗示阴司官僚体系",
    sref: "S10",
  },
  {
    id: "L15",
    name: "濮阳城隍庙出巡",
    category: "doc",
    region: "",
    source: "360doc 转载（链接待补）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "网络转载，可信度低。",
    usage: "城隍信仰背景了解，不直接入戏",
    sref: "S07",
  },
  {
    id: "L16",
    name: "扶乩（笔仙历史源头）",
    category: "doc",
    region: "",
    source: "《辞海》《中华道教大辞典》扶乩定义；黎志添《清代四种吕祖全书与吕祖扶乩道坛》（链接待补）；刘又榕论文（已登记 R06，当代角度）",
    url: "",
    status: "verified",
    citable: true,
    boundary: "「笔仙、碟仙为扶乩的民间简化／游戏化形态」表述时须标「有研究者认为」。",
    usage: "第3站旧课桌笔仙段落的历史背景",
    sref: "S11",
  },
  {
    id: "L17",
    name: "碟仙起源与「科学灵乩图」",
    category: "doc",
    region: "",
    source: "中新社报道（2010-12-09）；维基「碟仙」条（链接待补）",
    url: "https://www.chinanews.com.cn/cul/2010/12-09/2712299.shtml",
    status: "verified",
    citable: true,
    boundary: "碟仙 1930 年代起源于香港；1934 年徐桐「科学灵乩图」在上海《申报》刊登广告；1960 年代在台湾风靡。",
    usage: "第3站线索卡：旧课桌抽屉里 1930 年代式样的「灵乩图」广告单（形象借用）",
    sref: "S11",
  },
  {
    id: "L18",
    name: "借尸还魂（《子不语》）",
    category: "doc",
    region: "",
    source: "袁枚《子不语》卷一、卷二「灵璧女借尸还魂」条（乾隆二十一年，1756）",
    url: "",
    status: "verified",
    citable: true,
    boundary: "志怪笔记，非史实记录；只能支撑「借尸还魂」的文学存在，不支撑史实。",
    usage: "第9站、第11站文化注脚：「古书里写魂魄会走错身体，我们这里，是名字走错了地方」（只作比喻）",
    sref: "S12",
  },
  {
    id: "L19",
    name: "《搜神记》借尸还魂条目",
    category: "doc",
    region: "",
    source: "干宝《搜神记》（东晋），卷十五、卷十六",
    url: "",
    status: "pending",
    citable: false,
    boundary: "2026-10-02部分核对：鬼魂复生故事见卷十五、卷十六，借尸还魂故事群（颜畿、羊祜、杜锡婢等）位于卷十五末；缺汪绍楹校注本纸质页码，暂以书名+卷次层级引用，不作正式解谜依据。",
    usage: "与《子不语》并列的文学母题注脚",
    sref: "S12",
  },
  {
    id: "L20",
    name: "名即其身（以名驱魅）",
    category: "doc",
    region: "",
    source: "贺璐璐（枣庄学院文学院）《以名驱魅：出土简帛里的「名字」巫术》，澎湃「私家历史」；马王堆帛书《杂禁方》《五十二病方》、周家台秦简、睡虎地秦简",
    url: "https://www.thepaper.cn/newsDetail_forward_33668140",
    status: "verified",
    citable: true,
    boundary: "全作「错名」主题最硬的人类学支撑：名字附着于灵魂与身体。转述时必须保留「（据出土简帛研究）」限定语；弗雷泽《金枝》为转引。",
    usage: "第1站（街坊叫错名）、第4站（「沈｜归家」笔迹）、第11站（核名谜题）、第12站（把名字写回去）四站共用",
    sref: "S13",
  },
  {
    id: "O01",
    name: "吴承恩花果山隐居撰书说",
    category: "oral",
    region: "江苏连云港",
    source: "扬子晚报／紫牛新闻报道、CCTV 财经《消费主张》均以「相传」表述",
    url: "https://k.sina.com.cn/article_1653603955_628ffe7302001s4ma.html",
    status: "pending",
    citable: false,
    boundary: "地方宣传口径，未见方志或年谱实证，不得写成事实。 2026-10-02核对：与L02同源，\"据《淮安府志》记载\"系旅游宣传口径误引（天启《淮安府志》吴承恩传无此记载），仅可作\"相传\"口径使用，不可作解谜依据。",
    usage: "第8站旧戏台／第2站旧书摊背景，游戏中如使用须明确标注「相传」",
    sref: "S03",
  },
  {
    id: "O02",
    name: "送肉粽（送煞）",
    category: "oral",
    region: "台湾彰化沿海",
    source: "ETtoday 新闻报道（2019-02-28）",
    url: "https://www.ettoday.net/news/20190228/1389020.htm",
    status: "verified",
    citable: true,
    boundary: "彰化地方习俗的直接报道；不得写成「连云港也有送肉粽」，不可泛化。",
    usage: "第5站：2006 年红白相遇后老街流传「煞气未送走」的社会心理背景，不作超自然实证；第12站「送」字呼应送别",
    sref: "S06",
  },
  {
    id: "O03",
    name: "亡魂煞（干支算法）",
    category: "oral",
    region: "中原（具体流传地待核）",
    source: "360doc 民间丧葬流程转载（具体链接待补）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "网络转载，可信度低；干支算法细节未核实。",
    usage: "仅作背景参考，不得写入解谜逻辑",
    sref: "S07",
  },
  {
    id: "O04",
    name: "出殡路祭（香港现行习俗）",
    category: "oral",
    region: "香港",
    source: "维基「招魂」条相关记述：香港殡仪业至今保留出殡途中的路祭",
    url: "https://zh.wikipedia.org/wiki/招魂",
    status: "verified",
    citable: true,
    boundary: "引用时须限定为香港地区习俗。",
    usage: "第5站「石街送行」路祭流程的活态参照",
    sref: "S05",
  },
  {
    id: "O05",
    name: "白事白灯笼引路",
    category: "oral",
    region: "多地（未注明）",
    source: "163.com 网易号（链接待补）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "自媒体来源，仅作口头例证，不可作解谜依据。",
    usage: "第12站「引路」层意象参考；第5站送行队伍的白灯笼呼应",
    sref: "笔记二·4",
  },
  {
    id: "O06",
    name: "灵前长明油灯、烧「老盆」（罗圈村）",
    category: "oral",
    region: "罗圈村",
    source: "360doc 转载（链接待补）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "网络转载，原文待核对。",
    usage: "第12站「长明／留灯」层意象参考",
    sref: "S07",
  },
  {
    id: "O07",
    name: "红让白",
    category: "oral",
    region: "河南焦作",
    source: "极目新闻报道，经凤凰网、澎湃转载；新京报评论引钟敬文、费孝通",
    url: "https://news.ifeng.com/c/8nEg7jxFdgK",
    status: "verified",
    citable: true,
    boundary: "河南焦作地方习俗的新闻实证，不可写成全国统一习俗；「红白双煞」为本作虚构用语，见游戏虚构 F01。",
    usage: "2006 年暴雨夜红衣新娘与白衣死者队伍石巷相遇的直接现实原型：第5站线索卡、第1站街坊闲谈",
    sref: "S08",
  },
  {
    id: "O08",
    name: "谢范将军／七爷八爷",
    category: "oral",
    region: "闽南、台湾",
    source: "江义雄《台湾「黑白无常」与「范谢将军」研究》（2016，已登记 R07）",
    url: "",
    status: "verified",
    citable: true,
    boundary: "与黑白无常的对应关系各地不同，台湾称法存在争议、二者需区分；故事在苏北，不宜径用闽南典故，借用七爷八爷称谓须标口头。",
    usage: "第11站无常形象比较注脚",
    sref: "S09／R07",
  },
  {
    id: "O09",
    name: "碰姓／乞名（改名避凶）",
    category: "oral",
    region: "河南、陕西等地",
    source: "维基「碰姓」条，引郑小江主编《中国避邪文化》（当代世界出版社，2008，ISBN 9787509004036）",
    url: "https://zh.wikipedia.org/wiki/碰姓",
    status: "verified",
    citable: true,
    boundary: "地域限定在河南、陕西等地。",
    usage: "第11站「改名字」谜题注脚：「沈归这个名字，是跟一场雨乞来的」（文学化表达，标比喻）",
    sref: "S14",
  },
  {
    id: "O10",
    name: "祁东引路灯笼",
    category: "oral",
    region: "湖南祁东",
    source: "大风新闻祁东白事灯笼报道（163.com，原网易号）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "2026-10-02核对：原文链接已归档、实测可打开；维持\"仅作口头传说例证\"，不可作解谜依据。",
    usage: "引路灯笼口头例证，不可作解谜依据",
    sref: "S15",
  },
  {
    id: "O11",
    name: "改名禀报祖先",
    category: "oral",
    region: "未注明（当代命理说法）",
    source: "YouTube 命理说法（自媒体）",
    url: "",
    status: "pending",
    citable: false,
    boundary: "自媒体，仅记录「当代民间有此说法」，不作依据。",
    usage: "仅记录，不入戏作依据",
    sref: "S16",
  },
  {
    id: "F01",
    name: "红白双煞",
    category: "fiction",
    region: "",
    source: "本作设定，已登记 R09（story/SOURCES.md）",
    url: "",
    status: "verified",
    citable: false,
    boundary: "游戏虚构。无古籍版本、无历史引文；不得伪装成古代全国统一类别或连云老街居民口传。「红让白」习俗见口头 O07。",
    usage: "第5站街坊对白中红衣新娘与白衣死者队伍的临时叫法",
    sref: "R09",
  },
  {
    id: "F02",
    name: "客簿拘魂 · 错名机制",
    category: "fiction",
    region: "",
    source: "本作核心超自然规则（story/SOURCES.md 已声明）",
    url: "",
    status: "verified",
    citable: false,
    boundary: "游戏虚构。不是历史；其信仰逻辑支撑见文献 L20「名即其身」。",
    usage: "全作主线：第1、4、11、12站「名字写错，魂走错路」",
    sref: "本作设定",
  },
  {
    id: "F03",
    name: "点灯送魂／留灯守巷",
    category: "fiction",
    region: "",
    source: "本作第12站双结局规则",
    url: "",
    status: "verified",
    citable: false,
    boundary: "游戏虚构。「点灯能送亡魂离开」是本作规则，不得写成「某地习俗认为点灯可以送魂」；三层灯的意象出处见 L09／O05／O06。",
    usage: "第12站双结局：点亮一盏灯送母亲离开（归灯），或接灯守巷（留灯守巷）",
    sref: "本作设定",
  },
  {
    id: "F04",
    name: "无常受客簿调度 · 按簿核名",
    category: "fiction",
    region: "",
    source: "本作规则（story/SOURCES.md 已声明）",
    url: "",
    status: "verified",
    citable: false,
    boundary: "游戏虚构。无常形象本身有文献支撑（L12），但「受客簿调度、核名出错」为本作设定。",
    usage: "第11站核名谜题：无常只认客簿上的名字",
    sref: "本作设定",
  },
  {
    id: "F05",
    name: "笔仙「看见错读」",
    category: "fiction",
    region: "",
    source: "本作剧情装置（story/SOURCES.md 已声明）",
    url: "",
    status: "verified",
    citable: false,
    boundary: "游戏虚构。笔仙不是错名产生的史实解释；扶乩／碟仙源流见 L16／L17。",
    usage: "第3站 2006 年笔仙段落：笔尖越过竖线，把「沈｜归家」连成「沈归」",
    sref: "本作设定",
  },
];

export const CODEX_CATEGORY_LABEL: Record<CodexCategory, string> = {
  doc: '文献',
  oral: '口头传统',
  fiction: '游戏虚构',
};
